module.exports = __webpack_public_path__ + "static/media/user.215d2729.jpg";